import { Document, Font, Image, Page, PDFViewer, StyleSheet, Text, View } from "@react-pdf/renderer"
import React, { useEffect, useState } from "react"
import MontserratRegular from "../../assets/fonts/Montserrat-Regular.ttf"
import MontserratBold from "../../assets/fonts/Montserrat-Bold.ttf"
import MontserratSemiBold from "../../assets/fonts/Montserrat-SemiBold.ttf"
import MontserratItalic from "../../assets/fonts/Montserrat-Italic.ttf"
import { connect } from "react-redux"
import { withTranslation } from "react-i18next"
import { getSubdomain } from "../../components/shared/StylesheetInjector"
import { COMPLETED, PAID, SERVICE_DELETED } from "../../constants/statuses"
import { navigationPaths } from "../../constants/paths"
import { isDTCAFleet, isFleetAdvise, isFleetcor, isZubie } from "../../helpers/affiliationHelpers"
import { FLEETCOR } from "../../constants/application"
import LoadingThrobber from "../../components/shared/LoadingThrobber"
import { FAILURE } from "../../constants/notification"

Font.register({
  family: "Montserrat",
  fonts: [
    {
      src: MontserratRegular
    },
    {
      src: MontserratBold,
      fontWeight: "bold"
    },
    {
      src: MontserratSemiBold,
      fontWeight: "semibold"
    },
    {
      src: MontserratItalic,
      fontStyle: "italic"
    }
  ]
})
Font.registerHyphenationCallback((word) => [word])

const styles = StyleSheet.create({
  page: {
    paddingHorizontal: 0,
    fontSize: 10,
    fontFamily: "Montserrat",
    paddingBottom: 40
  },
  headerBackgroundColor: {
    fleetadvise: {
      backgroundColor: "#282F37"
    },
    zubie: {
      backgroundColor: "#000000"
    },
    fleetcor: {
      backgroundColor: "#000000"
    },
    fuelman: {
      backgroundColor: "#000000"
    },
    discounttire: {
      backgroundColor: "#F0F2F4"
    },
    mobileaseca: {
      backgroundColor: "#282F37"
    }
  },
  header: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    color: getSubdomain() === "discounttire" ? "black" : "white",
    padding: 20,
    marginBottom: 20,
    alignItems: "center"
  },
  table: {
    display: "table",
    width: "auto",
    borderColor: "#000",
    borderWidth: 0,
    borderRightWidth: 0,
    borderBottomWidth: 0
  },
  tableRow: {
    flexDirection: "row"
  },
  tableCol: {
    borderStyle: "solid",
    borderColor: "#000",
    borderWidth: 0,
    borderLeftWidth: 0,
    borderBottomWidth: 0,
    padding: 5
  },
  tableCell: {
    fontSize: 8,
    textAlign: "right"
  },
  total: {
    marginTop: 10,
    fontSize: 12,
    fontWeight: "bold"
  },
  subTotalSection: {
    textAlign: "right",
    marginTop: 10
  },
  infoSection: {
    backgroundColor: "#f4f4f4",
    flexGrow: "1",
    padding: "2px"
  },
  infoLabel: { flexDirection: "row", flexBasis: "48%", gap: "10px", alignItems: "center" },
  fontBold: { fontWeight: "bold" },
  fontSemiBold: { fontWeight: "semibold" },
  section: {
    marginBottom: 10
  },
  sectionHeader: {
    fontWeight: "bold",
    marginBottom: 0,
    fontSize: 12
  },
  separator: {
    marginVertical: 5,
    borderBottomWidth: 1,
    borderBottomColor: "#E2E5E9"
  },
  shopInformation: {
    display: "flex",
    flexDirection: "row",
    gap: "5px",
    marginBottom: "2px",
    alignItems: "center"
  },
  shopInformationLabel: { flexBasis: "35%", fontWeight: "semibold" },
  amountField: {
    display: "flex",
    flexDirection: "column",
    marginVertical: "2px",
    justifyContent: "space-between",
    gap: "10px"
  },
  piggyBank: {
    backgroundColor: "#282F37",
    padding: "0 15",
    borderBottomLeftRadius: "10px",
    borderTopLeftRadius: "10px",
    borderTopRightRadius: "4px",
    borderBottomRightRadius: "4px"
  },
  informationSection: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    flexWrap: "wrap"
  },
  fleetadvise: { width: "121px", height: "31" },
  mobileaseca: { width: "121px", height: "31" },
  zubie: { width: "90", height: "40" },
  fleetcor: { width: "162", height: "33" },
  fuelman: { width: "162", height: "33" },
  discounttire: { width: "223", height: "35" },
  piggyBankBgColor: {
    discounttire: {
      backgroundColor: "#1D2433"
    },
    fleetcor: {
      backgroundColor: "#E1261C"
    },
    fuelman: {
      backgroundColor: "#E1261C"
    },
    fleetadvise: {
      backgroundColor: "#1D2433"
    },
    mobileaseca: {
      backgroundColor: "#1D2433"
    },
    zubie: {
      backgroundColor: "#5742E0"
    }
  },
  headerReceipt: { display: "flex", flexDirection: "column", alignItems: "flex-end" },
  mutedLabel: { color: "#616161" },
  priceRow: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    marginVertical: "2px"
  },
  priceRowBold: { fontWeight: "bold" },
  priceDivider: {
    marginVertical: 4,
    borderBottomWidth: 1,
    borderBottomColor: "#d7d7d7"
  }
})

export const CARADVISE_NEW_TIRES = "CarAdvise New Tire(s)"
const TIRES_INSTALLATION = "Tire Installation"
const TIRES_DELIVERY_FEE = "Tire Delivery Fee"

export const InvoicePDF = ({ order, fleet, tireOrder }) => {
  const shop = order.shop
  const vehicle = order.vehicle
  const [total, setTotal] = useState(null)
  const services = order.order_services.filter(
    (service) => service.original_status !== SERVICE_DELETED
  )
  const [deliveryFee, setDeliveryFee] = useState(null)
  const [isTiresOrder, setIsTiresOrder] = useState(false)

  useEffect(() => {
    let totalLabourPrice = 0
    let totalPartsPrice = 0
    services.forEach((service) => {
      totalLabourPrice = Number(service.labor_total ?? 0) + totalLabourPrice
      totalPartsPrice = Number(service.override_parts_total ?? 0) + totalPartsPrice

      if (service.name === TIRES_DELIVERY_FEE) {
        setDeliveryFee(service.override_total)
      }

      if (service.name === CARADVISE_NEW_TIRES) {
        setIsTiresOrder(true)
        totalPartsPrice += Number(service.override_total) || 0
      }

      if (service.name === TIRES_INSTALLATION) {
        totalLabourPrice += Number(service.override_total) || 0
      }
    })
    setTotal({ totalPartsPrice, totalLabourPrice })
  }, [order])

  return (
    <Document title={"Invoice-" + order.id} subject={"Invoice-" + order.id}>
      <Page style={styles.page}>
        <Header order={order} />
        <View style={{ paddingHorizontal: 20, paddingBottom: 60 }}>
          <Receipt order={order} />
          <View style={styles.informationSection}>
            <ShopInformation shop={shop} fleet={fleet} />
            <VehicleInformation vehicle={vehicle} order={order} />
          </View>
          <LineItems services={services} tireOrder={tireOrder} />
          {isTiresOrder && (
            <Text style={{ paddingBottom: "5px" }}>
              Looking for detailed tire specs? Check your email receipt for the full breakdown.
            </Text>
          )}
          <PaymentSection order={order} total={total} deliveryFee={deliveryFee} />
        </View>
        <Footer vehicle={order.vehicle} />
      </Page>
    </Document>
  )
}

const Header = ({ order }) => (
  <View style={{ ...styles.header, ...styles.headerBackgroundColor[getSubdomain()] }} fixed>
    <View>
      <Image
        src={`/assets/white_label/logos/${getSubdomain()}.png`}
        style={styles[getSubdomain()]}
      />
    </View>
    <View
      style={styles.headerReceipt}
      render={({ pageNumber, totalPages }) => (
        <>
          <Text style={{ fontWeight: "bold", fontSize: "16", textAlign: "right" }}>RECEIPT</Text>
          <Text style={{ fontWeight: "bold", fontSize: "14", textAlign: "right" }}>
            Order #{order.id}
          </Text>
          <Text style={{ fontWeight: "bold", fontSize: "10", textAlign: "right" }}>
            {`Page ${pageNumber} of ${totalPages}`}
          </Text>
        </>
      )}
    />
  </View>
)

const Receipt = ({ order }) => (
  <View style={{ ...styles.section, width: "48%" }}>
    <View style={styles.shopInformation}>
      <Text style={styles.shopInformationLabel}>RECEIPT DATE</Text>
      <Text
        style={{
          ...styles.infoSection,
          fontWeight: "bold"
        }}
      >
        {convertToDateFormat(order.appointment_datetime)}
      </Text>
    </View>
    <View></View>
  </View>
)

const Footer = ({ vehicle }) => (
  <View
    style={{ position: "absolute", bottom: "0px", width: "100%", padding: "10px" }}
    fixed={true}
    render={({ pageNumber, totalPages }) => (
      <View
        style={{
          fontSize: "8px",
          display: "flex",
          flexDirection: "row",
          justifyContent: `${pageNumber === totalPages ? "space-between" : "flex-end"}`,
          fontStyle: "italic",
          alignItems: "flex-end"
        }}
      >
        {pageNumber === totalPages && (
          <View>
            {vehicle && vehicle.make && vehicle.make.toLowerCase().includes("toyota") && (
              <Text>
                *Portions of materials contained herein have been included under license from Toyota
                Motor Sales, U.S.A., Inc. License Agreement TMS1008.
              </Text>
            )}
            <Text>*Shop payment processed via CarAdvise.</Text>
            <Text>
              *The total amount shown may include price adjustments not reflected in the individual
              part or labor line items.
            </Text>
          </View>
        )}
        <Text style={{ textAlign: "right" }}>{`Page ${pageNumber} of ${totalPages}`}</Text>
      </View>
    )}
  />
)

const LineItems = ({ services, tireOrder }) => {
  return (
    <View style={styles.section}>
      <View style={styles.table}>
        <View fixed>
          <View style={styles.tableRow}>
            <View style={{ ...styles.tableCol, width: "80%" }}>
              <Text style={{ fontSize: 12, fontWeight: "bold", textAlign: "left" }}>SERVICES</Text>
            </View>
            <View style={{ ...styles.tableCol, ...styles.fontSemiBold, width: "12%" }}>
              <Text style={styles.tableCell}>Part Qty</Text>
            </View>
            <View style={{ ...styles.tableCol, ...styles.fontSemiBold, width: "12%" }}>
              <Text style={styles.tableCell}>Part Cost</Text>
            </View>
            <View style={{ ...styles.tableCol, ...styles.fontSemiBold, width: "14%" }}>
              <Text style={styles.tableCell}>Labor Cost</Text>
            </View>
            <View style={{ ...styles.tableCol, ...styles.fontSemiBold, width: "12%" }}>
              <Text style={styles.tableCell}>Total Cost</Text>
            </View>
          </View>
          <View style={{ ...styles.separator, marginVertical: "1" }} /> {/* Horizontal line */}
        </View>
        {services
          .filter((service) => service.original_status !== SERVICE_DELETED)
          .map((service) => {
            if (service.name === TIRES_DELIVERY_FEE) {
              return
            }
            let tireDetails
            let tireRim

            if (service.name === CARADVISE_NEW_TIRES) {
              const tire = tireOrder?.tire_orders[0]
              tireDetails = `${tire?.brand} ${tire?.tire_model}`
              tireRim = tire?.tire_details
            }

            return (
              <>
                <View style={{ ...styles.tableRow, alignItems: "flex-start" }} wrap={false}>
                  <View style={{ ...styles.tableCol, width: "80%" }}>
                    <View
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        marginVertical: "2px",
                        gap: "5px"
                      }}
                    >
                      <Text
                        style={{
                          flexBasis: "44%",
                          alignSelf: "flex-start",
                          fontSize: 10,
                          fontWeight: "semibold"
                        }}
                      >
                        Service Name
                      </Text>
                      <Text
                        style={{
                          flexGrow: "1",
                          width: "100%",
                          fontSize: 9,
                          lineHeight: tireDetails ? 1.5 : 1
                        }}
                      >
                        {service.name}
                        {service.name === CARADVISE_NEW_TIRES && tireDetails
                          ? `\n${tireDetails}\n${tireRim}`
                          : ""}
                      </Text>
                    </View>
                    {service.description && (
                      <View
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          marginVertical: "2px",
                          gap: "5px"
                        }}
                      >
                        <Text
                          style={{
                            flexBasis: "44%",
                            alignSelf: "flex-start",
                            fontSize: 10,
                            fontWeight: "semibold"
                          }}
                        >
                          Description
                        </Text>
                        <Text style={{ flexGrow: "1", width: "100%", fontSize: 9 }}>
                          {service.description}
                        </Text>
                      </View>
                    )}
                    {service.shop_comments && (
                      <View
                        style={{
                          display: "flex",
                          flexDirection: "row",
                          marginVertical: "2px",
                          gap: "5px"
                        }}
                      >
                        <Text
                          style={{
                            flexBasis: "44%",
                            alignSelf: "flex-start",
                            fontSize: 10,
                            fontWeight: "semibold"
                          }}
                        >
                          Shop Comments
                        </Text>
                        <Text style={{ flexGrow: "1", width: "100%", fontSize: 9 }}>
                          {service?.shop_comments.trim()}
                        </Text>
                      </View>
                    )}
                  </View>
                  <View style={{ ...styles.tableCol, width: "12%" }}>
                    <Text style={styles.tableCell}>{service.quantity ?? "-"}</Text>
                  </View>
                  <View style={{ ...styles.tableCol, width: "12%" }}>
                    <Text style={styles.tableCell}>
                      {service.override_parts_total
                        ? `$${Number(service.override_parts_total).toFixed(2)}`
                        : service.name === CARADVISE_NEW_TIRES
                        ? `$${Number(service.override_total / service.quantity).toFixed(2)}`
                        : "-"}
                    </Text>
                  </View>
                  <View style={{ ...styles.tableCol, width: "14%" }}>
                    <Text style={styles.tableCell}>
                      {service.labor_total
                        ? `$${Number(service.labor_total).toFixed(2)}`
                        : service.name === TIRES_INSTALLATION
                        ? `$${Number(service.override_total / service.quantity).toFixed(2)}`
                        : "-"}
                    </Text>
                  </View>
                  <View style={{ ...styles.tableCol, width: "12%" }}>
                    <Text style={styles.tableCell}>
                      {service.override_total
                        ? `$${Number(service.override_total).toFixed(2)}`
                        : "-"}
                    </Text>
                  </View>
                </View>
                <View style={{ ...styles.separator, marginVertical: "0" }} />{" "}
                {/* Horizontal line */}
              </>
            )
          })}
      </View>
    </View>
  )
}

const ShopInformation = ({ shop, fleet }) => (
  <View style={{ ...styles.section, flexBasis: "48%", width: "50%" }}>
    <Text style={{ ...styles.sectionHeader, ...styles.fontBold }}>SHOP INFORMATION</Text>
    <View style={{ ...styles.separator }} />
    <View style={styles.shopInformation}>
      <Text style={{ ...styles.shopInformationLabel, flexBasis: "55%", alignSelf: "flex-start" }}>
        NAME
      </Text>
      <Text style={{ ...styles.infoSection, width: "100%" }}>{shop.name}</Text>
    </View>
    <View style={{ ...styles.shopInformation, alignItems: "flex-start" }}>
      <Text style={{ ...styles.shopInformationLabel, flexBasis: "55%" }}>ADDRESS</Text>
      <Text style={{ ...styles.infoSection, width: "100%" }}>
        {[shop.address_line1, shop.city, shop.state, shop.zip].join(", ")}
      </Text>
    </View>
    <View style={styles.shopInformation}>
      <Text style={styles.shopInformationLabel}>PHONE</Text>
      <Text style={styles.infoSection}>{shop.main_phone_number}</Text>
    </View>

    <Text style={{ ...styles.sectionHeader, ...styles.fontBold, marginTop: "20" }}>
      FLEET INFORMATION
    </Text>
    <View style={{ ...styles.separator }} />
    <View style={styles.shopInformation}>
      <Text style={{ ...styles.shopInformationLabel, flexBasis: "55%", alignSelf: "flex-start" }}>
        FLEET NAME
      </Text>
      <Text style={{ ...styles.infoSection, width: "100%" }}>{fleet?.name}</Text>
    </View>
  </View>
)

const VehicleInformation = ({ vehicle, order }) => (
  <View style={{ ...styles.section, flexBasis: "48%" }}>
    <Text style={{ ...styles.sectionHeader, ...styles.fontBold }}>VEHICLE INFORMATION</Text>
    <View style={{ ...styles.separator }} />

    <View style={styles.shopInformation}>
      <Text style={styles.shopInformationLabel}>VIN</Text>
      <Text style={styles.infoSection}>{vehicle.vin ?? " "}</Text>
    </View>

    <View style={styles.shopInformation}>
      <Text style={styles.shopInformationLabel}>LICENSE PLATE</Text>
      <Text style={styles.infoSection}>
        {vehicle.license_plate_number?.trim() ? vehicle.license_plate_number : " "}
      </Text>
    </View>

    <View style={styles.shopInformation}>
      <Text style={styles.shopInformationLabel}>YEAR</Text>
      <Text style={styles.infoSection}>{vehicle.year ?? " "}</Text>
    </View>

    <View style={styles.shopInformation}>
      <Text style={styles.shopInformationLabel}>MAKE</Text>
      <Text style={styles.infoSection}>{vehicle.make ?? " "}</Text>
    </View>

    <View style={styles.shopInformation}>
      <Text style={styles.shopInformationLabel}>MODEL</Text>
      <Text style={styles.infoSection}>{vehicle.model ?? " "}</Text>
    </View>

    <View style={styles.shopInformation}>
      <Text style={styles.shopInformationLabel}>MILEAGE</Text>
      <Text style={styles.infoSection}>{Number(vehicle.miles).toLocaleString() ?? " "}</Text>
    </View>

    {vehicle.name_of_vehicle && isFleetcor() && (
      <View style={styles.shopInformation}>
        <Text style={styles.shopInformationLabel}>CARD NAME</Text>
        <Text style={styles.infoSection}>{vehicle.name_of_vehicle}</Text>
      </View>
    )}

    <View style={styles.shopInformation}>
      <Text style={styles.shopInformationLabel}>DEPARTMENT #</Text>
      <Text style={styles.infoSection}>
        {vehicle.department_number?.trim() ? vehicle.department_number : " "}
      </Text>
    </View>

    {!isFleetcor() && (
      <View style={styles.shopInformation}>
        <Text style={styles.shopInformationLabel}>OTHER ID</Text>
        <Text style={styles.infoSection}>{vehicle.other_id?.trim() ? vehicle.other_id : " "}</Text>
      </View>
    )}

    {order?.ai_originated ? (
      <View style={styles.shopInformation}>
        <Text style={styles.shopInformationLabel}>APPOINTMENT</Text>
        <Text style={styles.infoSection}>Walk-In</Text>
      </View>
    ) : (
      <View style={styles.shopInformation}>
        <Text style={styles.shopInformationLabel}>DRIVERS / ADMIN</Text>
        <Text style={styles.infoSection}>
          {order?.originator?.name ?? vehicle.driver_name ?? " "}
        </Text>
      </View>
    )}
  </View>
)

// order.promotions is optional: [{ name, percent, amount }]. When it is absent we fall
// back to the single order level promotional discount field.
const orderPromotions = (order) => {
  if (!Array.isArray(order?.promotions)) return []

  return order.promotions.filter((promotion) => promotion && (promotion.name || promotion.label))
}

const hasPromotionsBreakdown = (order) => orderPromotions(order).length > 0

const promotionsLabel = (order) =>
  orderPromotions(order)
    .map((promotion) => {
      const name = promotion.name || promotion.label
      const percent = promotion.percent != null ? promotion.percent : promotion.percentage
      return percent ? `${name} (${percent}%)` : name
    })
    .join(" + ")

const promotionsAmount = (order) => {
  const summed = orderPromotions(order).reduce(
    (sum, promotion) => sum + (Number(promotion.amount) || 0),
    0
  )

  return summed > 0 ? summed : Number(order?.promotional_discount) || 0
}

const hasPromotionalDiscount = (order) =>
  hasPromotionsBreakdown(order) || Number(order?.promotional_discount) > 0

const hasPrepayDiscount = (order) => Number(order?.prepay_discount) > 0

const hasCaradviseDiscount = (order) => Number(order?.caradvise_discount) > 0

const membershipDiscountAmount = (order) => Number(order?.membership_discount) || 0

const hasMembershipDiscount = (order) => membershipDiscountAmount(order) > 0

const hasCaradviseCash = (order) => Number(order?.total_rewards_credit) > 0

const hasPromoRows = (order) => hasPromotionalDiscount(order) || hasPrepayDiscount(order)

const hasDiscountRows = (order) =>
  hasCaradviseCash(order) || hasCaradviseDiscount(order) || hasMembershipDiscount(order)

const promoDeductions = (order) => {
  const promotional = hasPromotionalDiscount(order) ? promotionsAmount(order) : 0
  const prepay = hasPrepayDiscount(order) ? Number(order.prepay_discount) || 0 : 0

  return promotional + prepay
}

const discountDeductions = (order) => {
  let deductions = 0

  if (hasCaradviseCash(order)) deductions += Number(order.total_rewards_credit) || 0
  if (hasCaradviseDiscount(order)) deductions += Number(order.caradvise_discount) || 0
  if (hasMembershipDiscount(order)) deductions += membershipDiscountAmount(order)

  return deductions
}

const bottomOutAtZero = (num) => (num < 0 ? 0 : num)

// The running subtotals come from the order when the API supplies them, and are derived
// from the labor/parts line items otherwise.
const servicesTotalAmount = (order, total) => {
  const servicesTotal = Number(order?.services_total) || 0
  if (servicesTotal > 0) return servicesTotal

  const estimatedSubTotal = Number(order?.estimated_sub_total) || 0
  if (estimatedSubTotal > 0) return bottomOutAtZero(estimatedSubTotal)

  return Number(total?.totalLabourPrice ?? 0) + Number(total?.totalPartsPrice ?? 0)
}

const totalAfterPromos = (order, total) => {
  const apiTotalAfterPromos = Number(order?.total_after_promos) || 0
  if (apiTotalAfterPromos > 0) return apiTotalAfterPromos

  return bottomOutAtZero(servicesTotalAmount(order, total) - promoDeductions(order))
}

// The fleet flow supplies the post-promo-and-discount amount as order.override_total
// (the "Fleet approval pricing" field); fall back to estimated_total_pre_tax, then to a
// locally derived value when neither is present.
const totalAfterDiscounts = (order, total) => {
  const overrideTotal = Number(order?.override_total) || 0
  if (overrideTotal > 0) return overrideTotal

  const subTotal = Number(order?.estimated_total_pre_tax) || 0
  if (subTotal > 0) return subTotal

  return bottomOutAtZero(totalAfterPromos(order, total) - discountDeductions(order))
}

const formatAmount = (amount) => `$${(Number(amount) || 0).toFixed(2)}`
const formatDeduction = (amount) => `(${formatAmount(amount)})`

const PricingRow = ({ label, value, bold, muted, big }) => (
  <View style={styles.priceRow}>
    <Text
      style={{
        ...(bold ? styles.priceRowBold : {}),
        ...(muted ? styles.mutedLabel : {}),
        fontSize: big ? 12 : 10
      }}
    >
      {label}
    </Text>
    <Text
      style={{
        ...(bold ? styles.priceRowBold : {}),
        ...(muted ? styles.mutedLabel : {}),
        fontSize: big ? 12 : 10
      }}
    >
      {value}
    </Text>
  </View>
)

const PricingDivider = () => <View style={styles.priceDivider} />

const PricingInformation = ({ order, total, deliveryFee }) => {
  const promoRows = hasPromoRows(order)
  const discountRows = hasDiscountRows(order)
  const isTaxFinalized =
    Number(order?.transaction_fee) > 0 || [COMPLETED, PAID].includes(order?.status)
  const surchargePercent = Number(order?.applicable_surcharge_percent) || 0

  return (
    <>
      <View style={{ flexBasis: "50%" }}>
        {!isFleetcor() &&
          (order.braintree_payment_methods?.length > 0 ||
            order.check_payment_method_of_previous_transaction) && (
            <View style={{ padding: "10px", border: "2px solid #E2E5E9", borderRadius: "4px" }}>
              <View
                style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "2px" }}
              >
                <Text style={{ fontWeight: "bold", fontSize: "10px" }}>Payment Method:</Text>
                <Text>
                  {paymentType(
                    order.braintree_payment_methods?.[0]?.type ||
                      order.check_payment_method_of_previous_transaction
                  )}
                </Text>
              </View>
              {order.braintree_payment_methods?.[0]?.last_4 && (
                <View
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    alignItems: "center",
                    gap: "2px"
                  }}
                >
                  <Text
                    style={{
                      fontWeight: "bold",
                      fontSize: "10px"
                    }}
                  >
                    {order.braintree_payment_methods[0].type === "ach"
                      ? "Account Number:"
                      : "Card Number:"}
                  </Text>
                  <Text>{paymentNumber(order.braintree_payment_methods[0])}</Text>
                </View>
              )}
            </View>
          )}
        {isFleetcor() && (
          <View style={{ padding: "10px", border: "2px solid #E2E5E9", borderRadius: "4px" }}>
            <View
              style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "2px" }}
            >
              <Text style={{ fontWeight: "bold", fontSize: "10px" }}>Payment Method:</Text>
              <Text>Fuelman Account</Text>
            </View>
          </View>
        )}
      </View>
      <View style={{ width: "260px" }}>
        <PricingRow label="Labor" value={formatAmount(total?.totalLabourPrice ?? 0)} />
        <PricingRow label="Parts" value={formatAmount(total?.totalPartsPrice ?? 0)} />
        <PricingRow
          label="Services total"
          value={formatAmount(servicesTotalAmount(order, total))}
          bold
        />
        {hasPromotionalDiscount(order) && (
          <PricingRow
            label={hasPromotionsBreakdown(order) ? promotionsLabel(order) : "Promotional discount"}
            value={formatDeduction(promotionsAmount(order))}
            muted
          />
        )}
        {hasPrepayDiscount(order) && (
          <PricingRow
            label="5% Pay Ahead Discount"
            value={formatDeduction(order.prepay_discount)}
            muted
          />
        )}
        {promoRows && <PricingDivider />}
        {promoRows && (
          <PricingRow
            label="Total after promos"
            value={formatAmount(totalAfterPromos(order, total))}
            bold
          />
        )}
        {hasCaradviseCash(order) && (
          <PricingRow
            label="CarAdvise cash"
            value={formatDeduction(order.total_rewards_credit)}
            muted
          />
        )}
        {hasCaradviseDiscount(order) && (
          <PricingRow
            label="CarAdvise discount"
            value={formatDeduction(order.caradvise_discount)}
            muted
          />
        )}
        {hasMembershipDiscount(order) && (
          <PricingRow
            label={
              Number(order?.membership_discount_percent) > 0
                ? `Membership discount (${Number(order.membership_discount_percent)}%)`
                : "Membership discount"
            }
            value={formatDeduction(membershipDiscountAmount(order))}
            muted
          />
        )}
        {discountRows && <PricingDivider />}
        {discountRows && (
          <PricingRow
            label="Total after promos & discounts"
            value={formatAmount(totalAfterDiscounts(order, total))}
            bold
          />
        )}
        <PricingRow label="Tax" value={formatAmount(order?.tax_amount ?? 0)} muted />
        {(Number(order?.network_surcharge) || 0) > 0 && (
          <PricingRow
            label="Out-of-Network fee"
            value={formatAmount(order.network_surcharge)}
            muted
          />
        )}
        <PricingRow
          label="Transaction fee"
          value={formatAmount(order?.transaction_fee ?? 0)}
          muted
        />
        {deliveryFee !== null && (
          <PricingRow label="Delivery fee" value={formatAmount(deliveryFee)} />
        )}
        <PricingRow label="Total" value={formatAmount(order.estimated_total)} bold big />
      </View>
    </>
  )
}

const PaymentSection = ({ order, total, deliveryFee }) => (
  <View wrap={false}>
    <Text style={{ fontWeight: "bold", fontSize: "12px", marginBottom: "5px" }}>
      PAYMENT DETAILS:
    </Text>
    <View
      style={{
        marginLeft: "auto",
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        width: "100%"
      }}
    >
      <PricingInformation order={order} total={total} deliveryFee={deliveryFee} />
    </View>
    <Text
      style={{
        fontSize: "8px",
        fontStyle: "italic",
        textAlign: "right",
        marginTop: "5px",
        width: "100%"
      }}
    >
      *Promos and discounts cannot be applied to taxes or fees. Total subject to change based on
      final work order.
    </Text>
    <View style={{ ...styles.separator }} />
    <View
      style={{
        fontWeight: "bold",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-end",
        gap: "20px"
      }}
    >
      <Text>TOTAL AMOUNT PAID TO CARADVISE*</Text>
      <Text>${Number(order.estimated_total).toFixed(2)}</Text>
    </View>

    {getSubdomain() !== FLEETCOR && hasPromotionalDiscount(order) && (
      <View
        style={{
          display: "flex",
          flexDirection: "row",
          gap: "1px",
          fontSize: "14px",
          backgroundColor: "#F1F1F1",
          borderRadius: "4px",
          marginTop: "50px",
          justifyContent: "space-between"
        }}
      >
        <View style={{ padding: 20, width: "90%" }}>
          <Text style={{ fontWeight: "bold", fontSize: 14 }}>
            You saved {formatAmount(promotionsAmount(order))}
            <Text style={{ fontWeight: "normal", fontSize: 14 }}>
              {" "}
              by using CarAdvise {isFleetAdvise() && "for Business."}
              {!isFleetAdvise() && "through " + getAffiliation()}
            </Text>
          </Text>
        </View>
        <View style={{ ...styles.piggyBank, ...styles.piggyBankBgColor[getSubdomain()] }}>
          <Image
            src={"/assets/images/PiggyBank.png"}
            style={{ width: "60px", height: "50px", marginTop: "5px" }}
          />
        </View>
      </View>
    )}
  </View>
)

const ShowInvoice = ({ order, dispatch, match, fleet, history, token }) => {
  const [tireOrder, setTireOrder] = useState(null)

  useEffect(() => {
    dispatch({
      type: "SHOP_ORDER_LOAD_DETAILS_SAGA",
      payload: {
        shopOrderId: match.params.id
      }
    })
    dispatch({
      type: "CURRENT_USER_LOAD_SAGA"
    })
  }, [])

  useEffect(() => {
    if (order && order.status && ![COMPLETED, PAID].includes(order.status)) {
      history.push(navigationPaths.approvalsShow(order.id))
    }

    if (order?.order_services?.some((service) => service.name === CARADVISE_NEW_TIRES)) {
      dispatch({
        type: "TIRE_ORDER_DETAILS_SAGA",
        payload: match.params.id,
        callback: (res, data) => {
          if (data?.fleet_tire_shop_order) {
            setTireOrder(data.fleet_tire_shop_order)
          }
        }
      })
    }
  }, [order, token])

  useEffect(() => {
    dispatch({
      type: "SHOP_ORDER_LOAD_SAGA",
      payload: {
        shopOrderId: match.params.id,
        priceAsApprovalsLogic: true,
        useOrderShowEndpoint: true
      },
      callback: async (status, data) => {
        if (status === FAILURE) {
          history.replace(navigationPaths.approvalsShow(match.params.id))
        }
        dispatch({
          type: "VEHICLE_LOAD_SAGA",
          payload: {
            vehicleId: data.vehicle_id,
            options: {
              search: true
            }
          },
          callback: async (vehicleData) => {
            dispatch({
              type: "FLEET_LOAD_SAGA",
              payload: { fleetId: vehicleData.fleet_id }
            })
          }
        })
      }
    })
  }, [])

  return order && order.shop ? (
    <PDFViewer style={{ width: "100%", height: "100vh" }}>
      {order && order.shop && <InvoicePDF order={order} fleet={fleet} tireOrder={tireOrder} />}
    </PDFViewer>
  ) : (
    <div className="fullscreen-center">
      <LoadingThrobber visible={true} />
    </div>
  )
}

const paymentType = (payType) => {
  switch (payType) {
    case "ach":
      return "ACH"
    case "credit_card":
      return "Card Payment"
    case "Fleetcor":
      return "Fuelman Account"
    case "Wex":
      return "Wex"
    default:
      return ""
  }
}

const paymentNumber = (payment) => {
  switch (payment.type) {
    case "ach":
      return `*****${payment.last_4}`
    case "credit_card":
      return `**** **** **** ${payment.last_4}`
    default:
      return ""
  }
}

const getAffiliation = () => {
  if (isFleetcor()) return "Fuelman Maintenance."
  if (isZubie()) return "Zubie Smart Maintenance."
  if (isDTCAFleet()) return "Discount Tire Fleet Services."
  return ""
}

function convertToDateFormat(dateString) {
  const date = new Date(dateString)

  // Check if the date is valid
  if (isNaN(date.getTime())) {
    return null // or throw an error
  }

  // Extract components in UTC to prevent time zone shifts
  const month = String(date.getUTCMonth() + 1).padStart(2, "0")
  const day = String(date.getUTCDate()).padStart(2, "0")
  const year = date.getUTCFullYear()

  return `${month}/${day}/${year}`
}

const mapStateToProps = (state) => {
  return {
    isLoading: state.application.isLoading,
    isVehicleMHComplete: state.vehicles.isVehicleMHComplete,
    order: state.shopOrders.shopOrder,
    vehicle: state.shopOrders.shopOrder && state.shopOrders.shopOrder.vehicle,
    fleet: state.application.fleetSessionData || state.fleets.fleet,
    token: state?.application?.userSessionData?.authentication_token
  }
}

export default connect(mapStateToProps)(
  withTranslation([
    "shopOrders",
    "approvalsEmptyState",
    "approvalsForm",
    "approvalsInfoModal",
    "vehicle"
  ])(ShowInvoice)
)
